/* eslint-disable no-nested-ternary */
/* eslint-disable complexity */
/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @typescript-eslint/explicit-member-accessibility */

// https://bytedance.larkoffice.com/wiki/wikcndzNH5w6ilZNNmmYzI6yCjg
import { createMinimalBrowserClient } from '@slardar/web/esm/minimal';
import { fetchPlugin } from '@slardar/integrations/dist/fetch';
import { ajaxPlugin } from '@slardar/integrations/dist/ajax';
import { customPlugin } from '@slardar/integrations/dist/custom';
import { jsErrorPlugin } from '@slardar/integrations/dist/jsError';
import { formatUrl } from '../utils';
import { ZTIRegion } from '@byted/tiktok-zti-types';

class ISlardar {
  static _instance: ISlardar | null;

  public accountApiSlardar: ReturnType<typeof createMinimalBrowserClient> | undefined = undefined;

  static getSlardar(opt?: { sdkVersion: string; slardarGlobalName?: string; region: ZTIRegion }) {
    if (!this._instance) {
      if (!opt) {
        throw new Error('init slardar need region params');
      } else {
        this._instance = new ISlardar(opt);
        (window as any).$SECURE_MONITOR = this._instance;
      }
    }
    return this._instance;
  }

  static clearSlardar() {
    this._instance = null;
  }

  constructor(opt: { sdkVersion: string; slardarGlobalName?: string; region: ZTIRegion }) {
    const { sdkVersion, slardarGlobalName } = opt;
    // update context
    if (!ISlardar._instance) {
      this.accountApiSlardar = createMinimalBrowserClient();
      this.accountApiSlardar('init', {
        domain:
          opt.region === 'oci'
            ? 'https://mon16-normal-useast5.tiktokv.us'
            : opt.region === 'eu'
            ? 'https://mon-i18n.tiktokv.com'
            : 'https://mon.tiktokv.com',
        pluginPathPrefix:
          opt.region === 'oci'
            ? 'https://lf16-cdn-tos.tiktokcdn-us.com/obj/static-tx/slardar/fe/sdk-web/plugins'
            : 'https://sf16-website-login.neutral.ttwstatic.com/obj/tiktok_web_login_static/slardar/fe/sdk-web/plugins',
        bid: 'ucenter_tiktok_zti_sdk',
        pid: window?.location?.host,
        env: 'online',
        integrations: [
          fetchPlugin({
            // 是否默认hook 全局上的xhr
            autoWrap: false,
            ignoreUrls: [/^((?!\/passport\/).)*$/],
            // 请求错误 (response.statusCode >= 400) 时是否收集 request.body 与 response.body
            collectBodyOnError: true
          }),
          ajaxPlugin({
            // 是否默认hook 全局上的xhr
            autoWrap: false,
            ignoreUrls: [/^((?!\/passport\/).)*$/],
            // 请求错误 (response.statusCode >= 400) 时是否收集 request.body 与 response.body
            collectBodyOnError: true
          }),
          jsErrorPlugin({
            onerror: false,
            onunhandledrejection: false,
            dedupe: false,
            captureGlobalAsync: false
          }),
          customPlugin()
        ]
        // plugins: {
        //   tti: false,
        //   fmp: false,
        //   performance: false,
        //   resource: false,
        //   resourceError: false,
        //   pageview: false,
        //   jsError: {
        //     onerror: false,
        //     onunhandledrejection: false,
        //     dedupe: false,
        //     captureGlobalAsync: false
        //   },
        //   breadcrumb: {
        //     // 是否劫持 dom.click 与 dom.keypress 事件
        //     dom: false
        //   },
        //   ajax: {
        //     // 是否默认hook 全局上的xhr
        //     autoWrap: false,
        //     ignoreUrls: [/^((?!\/passport\/).)*$/],
        //     // 请求错误 (response.statusCode >= 400) 时是否收集 request.body 与 response.body
        //     collectBodyOnError: true
        //   },
        //   fetch: {
        //     // 是否默认hook 全局上的xhr
        //     autoWrap: false,
        //     ignoreUrls: [/^((?!\/passport\/).)*$/],
        //     // 请求错误 (response.statusCode >= 400) 时是否收集 request.body 与 response.body
        //     collectBodyOnError: true
        //   },
        //   blankScreen: {
        //     autoDetect: false, // 是否自动检测
        //     screenshot: false // 是否在判断为白屏的时候截屏上报
        //   }
        // }
      });
      this.accountApiSlardar('start');
      const container = this.checkEnv();
      this.accountApiSlardar('context.set', 'container', container);
      this.accountApiSlardar('context.set', 'sdkversion', sdkVersion);
      // 2023年04月18日16:50:15 下线
      // this.accountApiSlardar('sendEvent', {
      //   name: 'secure_sdk_web',
      // });
      ISlardar._instance = this;
    }
    return ISlardar._instance;
  }

  setContext = (obj: { [x: string]: any }) => {
    if (!this.accountApiSlardar) {
      return;
    }
    // eslint-disable-next-line guard-for-in
    for (const x in obj) {
      this.accountApiSlardar('context.set', x, obj[x]);
    }
  };

  setWebId = (webid: string) => {
    if (!ISlardar?._instance?.accountApiSlardar) {
      return;
    }
    ISlardar?._instance?.accountApiSlardar('config', { userId: webid });
  };

  setEnv = (env: string) => {
    if (!ISlardar?._instance?.accountApiSlardar) {
      return;
    }
    ISlardar?._instance?.accountApiSlardar('config', { env });
  };

  // 自定义打点
  dot(params: any) {
    if (!ISlardar?._instance?.accountApiSlardar) {
      return;
    }
    try {
      ISlardar?._instance?.accountApiSlardar('sendEvent', params);
    } catch (error) {
      console.log(error);
    }
  }

  // 自定义日志
  log(params: any) {
    if (!ISlardar?._instance?.accountApiSlardar) {
      return;
    }
    try {
      ISlardar?._instance?.accountApiSlardar('sendLog', params);
    } catch (error) {
      console.log(error);
    }
  }

  // 抛出错误
  throw(params: any) {
    if (!ISlardar?._instance?.accountApiSlardar) {
      return;
    }
    try {
      const { err, extra } = params;
      ISlardar?._instance?.accountApiSlardar('captureException', err, extra);
    } catch (error) {
      console.log(error);
    }
  }

  checkEnv() {
    const ua = window?.navigator.userAgent;
    const regex = /TTElectron/;
    if (regex.test(ua)) {
      return 'electron';
    }
    return 'web';
  }

  logRequestResponse(ctx: any, login: string) {
    try {
      let path = '';
      try {
        path = formatUrl(ctx?.config?.url);
      } catch (error) {}
      // const logid = ctx?.headers?.['x-tt-logid'] || '';
      // const ticketGuardVersion = ctx?.reqHeaders?.['tt-ticket-guard-version'] || '-99';
      // const ticketGuardIterationVersion = ctx?.reqHeaders?.['tt-ticket-guard-iteration-version'] || '-99';
      // const requestWithCsr = ctx?.reqHeaders?.['tt-ticket-guard-client-csr'] ? '1' : '0';
      // const requestWithCert = ctx?.reqHeaders?.['tt-ticket-guard-client-cert'] ? 1 : '0';
      // const requestWithClientData = ctx?.reqHeaders?.['tt-ticket-guard-client-data'] ? '1' : '0';
      // const verifyResponse = ctx?.headers?.['tt-ticket-guard-result'] || '-99';
      // const cookieStatus = ctx?.cookieStatus || '0';
      // const signVersion = ctx?.signVersion || '0';
      // const cookieCrypt = ctx?.cookieCrypt || '0';
      // const loginStatus = login;
      // const dataFrom = ctx?.dataFrom || '-99';
      // const crossStatus = ctx?.crossStatus || '-99';
      // const matchLocal = ctx?.match_md5_local || '-99';
      // const matchIframe = ctx?.match_md5_iframe || '-99';
      // const isConnection = ctx?.isConnection || '-99';
      // const retryCount = ctx?.retryCount || '-99';
      // const lost = ctx?.lost || '0';
      // const initMatch = ctx?.initMatch || '0';
      // this.dot({
      //   name: 'excute_response_verify_result',
      //   metrics: { count: 1 },
      //   categories: {
      //     status: ctx?.headers?.['tt-ticket-guard-result'] ? 'fail' : 'success',
      //     login: loginStatus,
      //     csr: requestWithCsr,
      //     cert: requestWithCert,
      //     server: requestWithClientData,
      //     verify: verifyResponse,
      //     version: ticketGuardVersion,
      //     signVersion,
      //     cookieStatus,
      //     path: path || '',
      //     cookieCrypt,
      //     dataFrom,
      //     crossStatus,
      //     matchLocal,
      //     matchIframe,
      //     isConnection,
      //     retryCount,
      //     lost,
      //     initMatch,
      //   },
      // });
      // this.log({
      //   extra: {
      //     logid,
      //     login: loginStatus,
      //     csr: requestWithCsr,
      //     cert: requestWithCert,
      //     server: requestWithClientData,
      //     verify: verifyResponse,
      //     version: ticketGuardVersion,
      //     iterVersion: ticketGuardIterationVersion,
      //     path: path || '',
      //     cookieCrypt,
      //     dataFrom,
      //     crossStatus,
      //     matchLocal,
      //     matchIframe,
      //     retryCount,
      //     isConnection,
      //   },
      //   content: 'log reponse verify result',
      //   level: 'info',
      // });
    } catch (error) {}
  }
}

export const getSlardar = (opt?: { sdkVersion: string; slardarGlobalName?: string; region: ZTIRegion }) => {
  try {
    if ((window as any).$SECURE_MONITOR) {
      return (window as any).$SECURE_MONITOR;
    }
    const instance = ISlardar.getSlardar(opt);
    if (instance) {
      return instance;
    } else {
      return opt ? new ISlardar(opt) : null;
    }
  } catch (e) {
    return null;
  }
};

export default ISlardar;
